/**
 * @generated SignedSource<<8c981525e15054e1a69c76992f4d83f7>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TradeBenefitsHero_viewer$data = {
  readonly user: {
    readonly profile: {
      readonly displayName: string | null;
    } | null;
    readonly tradeFirm: {
      readonly name: string | null;
      readonly publicProfile: {
        readonly profilePhoto: string | null;
      } | null;
      readonly rewards: {
        readonly currentProgram: {
          readonly programInfo: {
            readonly shortCopy: string | null;
          } | null;
        } | null;
        readonly statusYears: ReadonlyArray<number | null> | null;
      } | null;
      readonly " $fragmentSpreads": FragmentRefs<"TradeBenefitsHeroStatusContact_tradeFirm" | "TradeBenefitsHeroStatus_tradeFirm">;
    } | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"TradeBenefitsHeroActions_viewer" | "TradeBenefitsHeroStatusContact_viewer" | "TradeBenefitsHeroStatus_viewer">;
  readonly " $fragmentType": "TradeBenefitsHero_viewer";
};
export type TradeBenefitsHero_viewer$key = {
  readonly " $data"?: TradeBenefitsHero_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"TradeBenefitsHero_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "TradeBenefitsHero_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TradeBenefitsHeroStatus_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TradeBenefitsHeroActions_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TradeBenefitsHeroStatusContact_viewer"
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "userId",
          "variableName": "userId"
        }
      ],
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Profile",
          "kind": "LinkedField",
          "name": "profile",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "displayName",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "TradeFirmType",
          "kind": "LinkedField",
          "name": "tradeFirm",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "TradeFirmPublicProfileType",
              "kind": "LinkedField",
              "name": "publicProfile",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "profilePhoto",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "TradeFirmRewards",
              "kind": "LinkedField",
              "name": "rewards",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ParentProgram",
                  "kind": "LinkedField",
                  "name": "currentProgram",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "LoyaltyProgram",
                      "kind": "LinkedField",
                      "name": "programInfo",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "shortCopy",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "statusYears",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "TradeBenefitsHeroStatus_tradeFirm"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "TradeBenefitsHeroStatusContact_tradeFirm"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "bc2b4282c975a13d56ddec4c697bef54";

export default node;
